/**
 * External dependencies
 */
import React, { memo } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';

/**
 * Internal dependencies
 */
import AppSideBar from './AppSideBar';
import { DRAWER_WIDTH } from './useData';

function SideBar(): React.ReactElement {
  /* Global & Local State */
  /* Main */
  return (
    <Box sx={{ height: '100%' }}>
      <Box
        sx={{
          display: {
            xss: 'none',
            xs: 'none',
            sm: 'none',
            md: 'none',
            lg: 'block'
          },
          width: `${DRAWER_WIDTH}px`,
          flexShrink: { xs: 1, sm: 0 }
        }}
      >
        <Drawer
          variant="persistent"
          sx={{
            '& > .MuiPaper-root': {
              width: `${DRAWER_WIDTH}px`,
              overflowY: 'hidden'
            }
          }}
          open
        >
          <AppSideBar />
        </Drawer>
      </Box>
    </Box>
  );
}

export default memo(SideBar);
